import type { ReactElement } from 'react'
import type { TFunction } from 'i18next'
import type { ListEndpointsQuery } from '../../../types/case-container'
import type { ActiveFilter, FilterDefinition } from './case-infrastructure-tab.helpers'
import {
  ActiveFiltersRow,
  FilterDropdown,
  SearchBox,
  SearchButton,
  SelectionBar,
} from './case-infrastructure-filters/case-infrastructure-filters.parts'

export interface CaseInfrastructureFiltersProps {
  t: TFunction<'cases'>
  filterDropdownRef: React.RefObject<HTMLDivElement>
  showFilterDropdown: boolean
  setShowFilterDropdown: (v: boolean | ((prev: boolean) => boolean)) => void
  selectedFilterField: FilterDefinition | null
  setSelectedFilterField: (v: FilterDefinition | null) => void
  availableFilters: FilterDefinition[]
  addFilter: (def: FilterDefinition, value: string) => void
  searchInput: string
  setSearchInput: (v: string) => void
  handleSearchKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
  clearSearch: () => void
  executeSearch: () => void
  loading: boolean
  activeFilters: ActiveFilter[]
  removeFilter: (id: keyof ListEndpointsQuery) => void
  activeSearch: string
  clearAllFilters: () => void
  selectionCount: number
  clearAll: () => unknown
}

export function CaseInfrastructureFilters(props: CaseInfrastructureFiltersProps): ReactElement {
  return (
    <>
      <div className="flex gap-2">
        <FilterDropdown
          filterDropdownRef={props.filterDropdownRef}
          showFilterDropdown={props.showFilterDropdown}
          setShowFilterDropdown={props.setShowFilterDropdown}
          selectedFilterField={props.selectedFilterField}
          setSelectedFilterField={props.setSelectedFilterField}
          availableFilters={props.availableFilters}
          addFilter={props.addFilter}
        />
        <SearchBox
          searchInput={props.searchInput}
          setSearchInput={props.setSearchInput}
          handleSearchKeyDown={props.handleSearchKeyDown}
          clearSearch={props.clearSearch}
          t={props.t}
        />
        <SearchButton loading={props.loading} onClick={props.executeSearch} />
      </div>
      {(props.activeFilters.length > 0 || props.activeSearch) && (
        <ActiveFiltersRow
          activeFilters={props.activeFilters}
          removeFilter={props.removeFilter}
          activeSearch={props.activeSearch}
          clearSearch={props.clearSearch}
          clearAllFilters={props.clearAllFilters}
        />
      )}
      {props.selectionCount > 0 && (
        <SelectionBar selectionCount={props.selectionCount} clearAll={props.clearAll} />
      )}
    </>
  )
}
